// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/modules/components/pavilion.less
// module id = 417
// module chunks = 0